import { render, staticRenderFns } from "./AdminAccounting.vue?vue&type=template&id=529c0b16&scoped=true&"
import script from "./AdminAccounting.vue?vue&type=script&lang=js&"
export * from "./AdminAccounting.vue?vue&type=script&lang=js&"
import style0 from "./AdminAccounting.vue?vue&type=style&index=0&id=529c0b16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529c0b16",
  null
  
)

export default component.exports